import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const SingleCard = styled(Flex)`
  background: ${props => props.background};
  padding: ${props => (props.padding ? props.padding : 0)};
  border-radius: 10px;
  width: ${props => props.width};
  height: ${props => (props.height ? props.height : 'auto')};
  cursor: pointer;
  transition: 0.5s;
  :hover {
    background-color: ${COLORS.BLUE_T_80};
  }
`

export const CardText = styled.p`
  margin-top: 35px;
  font-style: normal;
  font-weight: ${FONT?.FW_500};
  font-size: ${FONT?.F_BASE};
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
  margin-top: 20px;
`
export const CardValue = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: ${FONT?.FW_700};
  font-size: 22px;
  line-height: 28px;
  color: ${COLORS.GREY_T_20};
  display: flex;
  gap:7px;
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  margin-top: -5px;

`
export const CursorPointer = styled.div`
  cursor: pointer;
  text-align: center;
  align-self: center;
`
export const SubText = styled.p`
  font-style: normal;
  font-weight: ${FONT?.FW_500};
  font-size: ${FONT?.F_XS};
  color: ${COLORS.GREY_T_60};
  line-height: 28px;
  margin: 3px;
  padding-right: 7px;
  padding-left: 6px;
`
